<ng-container *appI18nScopeReady>
  @if (authService.user$ | async; as user) {
  <div class="user-box" [matMenuTriggerFor]="userMenu">
    <mat-icon class="user-icon">account_circle</mat-icon>
    <span class="user-name">{{ user.name | uppercase }}</span>
    <mat-icon class="arrow-icon">arrow_drop_down</mat-icon>
  </div>

  <mat-menu #userMenu="matMenu" xPosition="before">
    <button mat-menu-item (click)="onToggleTheme()">
      <mat-icon>{{ themeService.isDarkMode() ? 'light_mode' : 'dark_mode' }}</mat-icon>
      <span>{{ themeService.isDarkMode() ? ('light_mode' | i18n) : ('dark_mode' | i18n) }}</span>
    </button>
    <button *appHasPermission="Permissions.GLOBAL_ADMIN" mat-menu-item (click)="onAdmin()">
      <mat-icon>admin_panel_settings</mat-icon>
      <span>{{ 'admin_option' | i18n }}</span>
    </button>
    <button *appHasPermission="Permissions.GLOBAL_ADMIN" mat-menu-item (click)="onAudit()">
      <mat-icon>history</mat-icon>
      <span>{{ 'audit' | i18n }}</span>
    </button>
    <button *appHasPermission="Permissions.GLOBAL_ADMIN" mat-menu-item (click)="onPreviewRole()">
      <mat-icon>visibility</mat-icon>
      <span>{{ 'preview_as_role' | i18n }}</span>
    </button>
    <button mat-menu-item (click)="onSensorMetaEditorNavigate()"
      *appHasPermission="Permissions.VIEW_SENSOR_META_EDITOR"
    >
      <mat-icon>tune</mat-icon>
      <span>{{ 'sensor_meta_editor_nav_btn' | i18n }}</span>
    </button>
    @if (isRouteVisible('/project-settings')) {
      <button mat-menu-item (click)="onProjectSettingsNavigate()">
        <mat-icon>settings</mat-icon>
        <span>{{ 'project_settings_nav_btn' | i18n }}</span>
      </button>
    }
    @if (isRouteVisible('/metrics-status')) {
      <button
        *appHasPermission="Permissions.RECOMPUTE_METRICS"
        mat-menu-item
        (click)="onMetricsStatusNavigate()"
      >
        <mat-icon>monitoring</mat-icon>
        <span>{{ 'metrics_status_nav_btn' | i18n }}</span>
      </button>
    }
    <!-- Opens a dialog, not a route, so it can't be looked up in multi-plant-visibility.ts -->
    @if (!isMultiPlantProject()) {
      <button
        *appHasPermission="Permissions.EDIT_TIMESERIES"
        mat-menu-item
        (click)="onImportStatusNavigate()"
      >
        <mat-icon>file_present</mat-icon>
        <span>{{ 'import_export_nav_btn' | i18n }}</span>
      </button>
    }
    @if (projectService.currentProject()) {
      <button mat-menu-item (click)="onCloseProject()">
        <mat-icon>close</mat-icon>
        <span>{{ 'close_project_option' | i18n }}</span>
      </button>
    }
    <button mat-menu-item (click)="onLogout()">
      <mat-icon>logout</mat-icon>
      <span>{{ 'user_logout_option' | i18n }}</span>
    </button>
  </mat-menu>
  }
</ng-container>
